import React from 'react';

import type { ImageData } from '../../../types/blog';

interface ImageProps {
  data: ImageData;
}

const Image: React.FC<ImageProps> = ({ data }) => {
  const { url, alt = '', caption } = data;
  const imageAlt = alt.trim() || caption?.trim() || 'Blog article illustration';

  if (!url) return null;

  return (
    <figure className="my-2">
      <img
        src={url}
        alt={imageAlt}
        className="w-full rounded-xl object-cover border vscode-border"
        loading="lazy"
      />
      {caption && (
        <figcaption className="mt-2 text-center text-sm vscode-text-secondary italic">
          {caption}
        </figcaption>
      )}
    </figure>
  );
};

export default Image;
